(() => {
  try {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    ['zip', 'lat', 'lng'].forEach(key => {
      if (params.has(key)) params.set(key, '');
    });
    const newUrl = `${url.pathname}?${params.toString()}`;
    if (newUrl !== window.location.href) {
      window.history.replaceState(null, '', newUrl);
    }
  } catch (err) {}
})();

document.addEventListener('DOMContentLoaded', () => {
  const selectors = {
    listTab: '.list_view_tab',
    mapTab: '.map_view_tab',
    resultsList: '.store-locator__results-list',
    resultListLabel: '.list-map-result',
    mapContainer: '.store-locator__map',
    zipInput: '.store-locator__filters-zip input[name="zip"]'
  };

  const els = Object.fromEntries(
    Object.entries(selectors).map(([key, sel]) => [key, document.querySelector(sel)])
  );

  const isMobile = () => window.innerWidth <= 768;

  const setView = (view) => {
    const showList = view === 'list';
    if (els.resultsList) els.resultsList.style.display = showList ? 'block' : 'none';
    if (els.resultListLabel) els.resultListLabel.style.display = showList ? 'block' : 'none';
    // if (els.mapContainer) els.mapContainer.style.display = showList ? 'none' : 'block';
    els.listTab?.classList.toggle('active', showList);
    els.mapTab?.classList.toggle('active', !showList);
    const mapContainer = document.querySelector(selectors.mapContainer);
    if(!showList) mapContainer.style = "display:block";
    if(showList) mapContainer.style = "display:none";
  };

  if (els.zipInput) els.zipInput.value = '';

  if (isMobile()) setView('list');

  els.listTab?.addEventListener('click', () => isMobile() && setView('list'));
  els.mapTab?.addEventListener('click', () => isMobile() && setView('map'));

  window.addEventListener('resize', () => {
    if (isMobile()) {
      setView(els.listTab?.classList.contains('active') ? 'list' : 'map');
    } else {
      if (els.resultsList) els.resultsList.style.display = 'block';
      if (els.resultListLabel) els.resultListLabel.style.display = 'block';
      if (els.mapContainer) els.mapContainer.style.display = 'block';
    }
  });
});


const slugify = (text) => {
  if (!text) {
    return '';
  }

  let slug = text.toLowerCase().trim();
  slug = slug.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  slug = slug.replace(/[^a-z0-9\s-]/g, ' ');
  slug = slug.replace(/\s+/g, '-');
  slug = slug.replace(/-+/g, '-').replace(/^-+|-+$/g, '');

  return slug;
}

class StoreLocator extends HTMLElement {
    constructor() {
        super();

        this.storeData = window.storeData || [];
        this.mapContainer = document.getElementById('google-map');
        this.storeListItems = this.querySelectorAll('.store-locator__results-item');
        this.noResultsMessage = this.querySelector('.store-locator__results-noresults');

        // Search/Filter elements
        this.zipInput = this.querySelector('.store-locator__filters-zip input');
        this.radiusInput = this.querySelector('.store-locator__filters-radius select');
        this.locationTypeCheckboxes = this.querySelectorAll('.store-locator__filters-location-type input');
        this.applianceDisplayCheckbox = this.querySelector('.store-locator__filters-location-feature-appliancedisplay');
        this.submitButton = this.querySelector('.store-locator__filters-submit');
        this.clearButton = this.querySelector('.store-locator__filters-clear');

        // Data attributes
        this.googleMapsApiKey = this.getAttribute('data-google-api-key');
        this.googleMapsId = '12345'; // TODO replace with actual map id once created in google console
        this.defaultLatitude = 33.744807080315866;
        this.defaultLongitude = -84.39274380401888;
        this.allowedRadius = ['10', '25', '50', '75', '100'];
        this.allowedLocationTypes = ['Showroom', 'Branch', 'KOHLER Store'];
        this.allowedFeature = 'Appliance Display';

        // Google Maps
        this.googleMap = null;
        this.mapMarkers = new Map();
        this.infoWindows = new Map();
        this.mapBounds = null;
        this.activeInfoWindow = null;
        this.activeMarker = null;
        this.maximumZoom = 12;

        // State
        this.filteredData = this.storeData;
        this.selectedLocationTypes = Array.from(this.locationTypeCheckboxes).map((x)=>x.value);
        this.isApplianceDisplay = false;
        this.latitude = '';
        this.longitude = '';
        this.radius = 10;

        this.init();
    }

    clearMapState() {
        console.log(this.infoWindows)

    }

    async init() {
        this.addEventListeners();
        this.processQueryString();
        await this.initGoogleMapsScripts(this.googleMapsApiKey);
        await this.initGoogleMap();
        this.updateFilteredData();

        // only check for browser location if we didn't get a location from the query string
        if (isNaN(this.latitude) || isNaN(this.longitude) || this.latitude == 0 || this.longitude == 0) {
            const hasBrowserLocation = await this.getBrowserGeoLocation();

            if (hasBrowserLocation) {
                try {
                    const zipCode = await this.getZipCodeFromLatLng(this.latitude, this.longitude);

                    if (zipCode) {
                        this.zipInput.value = zipCode;
                        this.radiusInput.disabled = false;
                        this.updateFilteredData();
                        this.refreshQueryString(['zip', 'lat', 'lng'], [zipCode, this.latitude, this.longitude]);
                    }
                } catch (error) {
                    console.warn('Error getting zip code from coords:', error);
                }
            }
        }
    }

    addEventListeners() {
        // Click on location type checkboxes
        this.locationTypeCheckboxes.forEach((checkbox) => {
            checkbox.addEventListener('click', this.handleLocationTypeFilterClick.bind(this));
        });

        // Click on Appliance Display checkbox
        if (this.applianceDisplayCheckbox) {
            this.applianceDisplayCheckbox.addEventListener('click', this.handleApplianceDisplayFilterClick.bind(this));
        }

        // Zip code input on change
        if (this.zipInput) {
            this.zipInput.addEventListener('input', this.handleZipCodeChange.bind(this));
        }

        // Submit zip code
        if (this.submitButton) {
            this.submitButton.addEventListener('click', this.handleSubmitButtonClick.bind(this));
        }

        // Clear results
        if (this.clearButton) {
            this.clearButton.addEventListener('click', this.handleClearFiltersClick.bind(this));
        }

        // Change radius
        if (this.radiusInput) {
            this.radiusInput.addEventListener('change', this.handleRadiusChange.bind(this));
        }

        // Show info window when clicking on list item
        this.storeListItems.forEach((item) => {
            item.addEventListener('click', this.handleListItemClick.bind(this));
        });

        this.querySelector(".filter-target-clear-wrap .icon-target").addEventListener("click", this.handleGetLocationClick.bind(this));
    }

    async handleGetLocationClick(){
        const hasBrowserLocation = await this.getBrowserGeoLocation();

        if (hasBrowserLocation) {
            try {
                const zipCode = await this.getZipCodeFromLatLng(this.latitude, this.longitude);

                if (zipCode) {
                    this.zipInput.value = zipCode;
                    this.radiusInput.disabled = false;
                    this.updateFilteredData();
                    this.refreshQueryString(['zip', 'lat', 'lng'], [zipCode, this.latitude, this.longitude]);
                }
            } catch (error) {
                console.warn('Error getting zip code from coords:', error);
            }
        }
    }

    // Event Handlers
    async handleSubmitButtonClick(e) {
        e.preventDefault();

        const zipCode = this.zipInput.value;

        if (zipCode.length != 5) {
            // TODO: replace once frontend specifics are in place
            alert('Invalid zip code.');
            return;
        }

        try {
            const location = await this.geolocateZipCode(zipCode);

            if (location) {
                this.latitude = location.lat;
                this.longitude = location.lng;

                this.updateFilteredData();
                this.refreshQueryString(['zip', 'lat', 'lng'], [zipCode, this.latitude, this.longitude]);
            } else {
                throw new Error('Geocoding failed');
            }
        } catch (error) {
            console.warn('Error handling submit:', error);
            // TODO: replace once frontend specifics are in place
            alert('Invalid zip code.');
        }
    }

    // handleLocationTypeFilterClick(e) {
    //     const checkbox = e.target;

    //     if (checkbox) {
    //         console.log(this.selectedLocationTypes)
    //         if (checkbox.checked && !this.selectedLocationTypes.includes(checkbox.value)) {
    //             this.selectedLocationTypes.push(checkbox.value);
    //         } else if (!checkbox.checked && this.selectedLocationTypes.includes(checkbox.value)) {
    //             this.selectedLocationTypes = this.selectedLocationTypes.filter((x) => x !== checkbox.value);
    //         }
    //         this.updateFilteredData();
    //         this.refreshQueryString(['location_type'], [this.selectedLocationTypes.join('|')]);
    //         if (this.infoWindows && this.infoWindows.size > 0) {
    //             for (const infoWindow of this.infoWindows.values()) {
    //                 infoWindow.close(); // 🔥 this hides the window from the map
    //             }
    //         }
    //         this.activeInfoWindow.close();
    //     }
    // }

    handleLocationTypeFilterClick(e) {
        const checkbox = e.target;
        if (!checkbox) return;

        const selected = [...this.selectedLocationTypes];

        if (checkbox.checked) {
            if (!selected.includes(checkbox.value)) {
                selected.push(checkbox.value);
            }
        } else {
            const index = selected.indexOf(checkbox.value);
            if (index > -1) {
                selected.splice(index, 1);
            }
        }

        this.selectedLocationTypes = selected;

        this.updateFilteredData();

        this.refreshQueryString(['location_type'], [this.selectedLocationTypes.join('|')]);

        // Close any open info windows
        if (this.infoWindows && this.infoWindows.size > 0) {
            for (const infoWindow of this.infoWindows.values()) {
                infoWindow.close();
            }
        }
        if (this.activeInfoWindow) {
            this.activeInfoWindow.close();
        }
    }


    handleApplianceDisplayFilterClick() {
        this.isApplianceDisplay = this.applianceDisplayCheckbox.checked;
        this.updateFilteredData();
        this.refreshQueryString(['appliance_display'], [this.isApplianceDisplay ? '1' : '']);
    }

    handleRadiusChange() {
        this.radius = this.radiusInput.value;
        this.updateFilteredData();
        this.refreshQueryString(['radius'], [this.radius]);
    }

    handleClearFiltersClick(e) {
        e.preventDefault();

        this.latitude = 0;
        this.longitude = 0;
        this.zipInput.value = '';
        this.radius = 10;
        this.radiusInput.value = 10;
        this.radiusInput.disabled = true;
        this.isApplianceDisplay = false;
        this.applianceDisplayCheckbox.checked = false;
        // this.locationTypeCheckboxes.forEach((x) => (x.checked = false));

        this.updateFilteredData();
        this.refreshQueryString(['zip', 'lat', 'lng', 'location_type', 'appliance_display', 'radius'], ['', '', '', '', '', '10']);
    }

    handleZipCodeChange(e) {
        const value = e.target.value;

        //only allow numbers
        e.target.value = value.replace(/\D/g, '');
        this.radiusInput.disabled = e.target.value.length != 5;
    }

    handleListItemClick(e) {
        const listItem = e.target.closest('[data-handle]');
        if (!listItem) return; 
        const handle = listItem.dataset.handle
        
        if (handle) {
            this.storeListItems.forEach(x => {
                x.classList.remove("active")
            });
            const marker = this.mapMarkers.get(handle);
            if (marker && marker != this.activeMarker) {
                marker.click();
            }
            listItem.classList.add("active");
        }

    }

    // Core functionality methods
    async geolocateZipCode(zipCode) {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(zipCode)}&key=${this.googleMapsApiKey}`;

        const response = await fetch(url);
        const data = await response.json();

        if (data.status === 'OK' && data.results.length > 0) {
            const location = data.results[0].geometry.location;
            return location;
        } else {
            throw new Error('Geocoding failed');
        }
    }

    async getZipCodeFromLatLng(lat, lng) {
        const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${this.googleMapsApiKey}`;
        const response = await fetch(url);
        const data = await response.json();

        if (data.status === 'OK' && data.results.length > 0) {
            for (const result of data.results) {
                for (const component of result.address_components) {
                    if (component.types.includes('postal_code')) {
                        return component.long_name;
                    }
                }
            }
            throw new Error('Zip code not found in response.');
        } else {
            throw new Error('Geocoding failed');
        }
    }

    async getBrowserGeoLocation() {
        try {
            const position = await this.getCurrentPositionAsync();
            this.latitude = position.coords.latitude;
            this.longitude = position.coords.longitude;
            return true;
        } catch (error) {
            console.warn('Geolocation failed:', error);
        }

        return false;
    }

    getCurrentPositionAsync(options) {
        return new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject, options));
    }

    processQueryString() {
        const urlParams = new URLSearchParams(window.location.search);

        // this.selectedLocationTypes = [];
        this.isApplianceDisplay = false;

        const lat = parseFloat(urlParams.get('lat'));
        if (!isNaN(lat) && lat != 0) {
            this.latitude = lat;
        }

        const lng = parseFloat(urlParams.get('lng'));
        if (!isNaN(lng) && lng != 0) {
            this.longitude = lng;
        }

        const radius = urlParams.get('radius');
        if (this.allowedRadius.includes(radius)) {
            this.radius = radius;
            this.radiusInput.value = radius;
        }

        let locationTypes = urlParams.get('location_type');
        if (locationTypes) {
            locationTypes = locationTypes.split('|');
            locationTypes.forEach((type) => {
                if (this.allowedLocationTypes.includes(type)) {
                    this.selectedLocationTypes.push(type);

                    const checkbox = this.querySelector(`input[value="${type}"]`);
                    if (checkbox) {
                        checkbox.checked = true;
                    }
                }
            });
        }

        if (urlParams.get('appliance_display') === '1') {
            this.isApplianceDisplay = true;
            this.applianceDisplayCheckbox.checked = true;
        }

        if (this.zipInput) {
            let zip = urlParams.get('zip') ?? '';
            zip = zip.replace(/\D/g, '');

            if (zip.length == 5) {
                this.zipInput.value = zip;
                this.radiusInput.disabled = false;
            }
        }
    }

    refreshQueryString(keys, values) {
        if (!Array.isArray(keys) || !Array.isArray(values) || keys.length != values.length) {
            return;
        }

        const params = new URLSearchParams(window.location.search);
        keys.forEach((key, index) => {
            params.set(key, values[index]);
        });

        const newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?${params.toString()}`;
        window.history.pushState({}, '', newUrl);
    }

    updateFilteredData() {
        this.filteredData = this.storeData;


        // Calculate distance from user's location and filter based on radius
        if (this.latitude && this.longitude) {
            this.filteredData = this.filteredData.filter((item) => {
                item.contact.distance = this.getDistanceInMiles(this.latitude, this.longitude, item.contact.latitude, item.contact.longitude);

                return item.contact.distance <= this.radius;
            });
        } else {
            this.filteredData.forEach((x) => (x.contact.distance = 0));
        }

        // if (this.filteredData.length && this.selectedLocationTypes.length) {
        //     this.filteredData = this.filteredData.filter((x) => this.selectedLocationTypes.includes(x.type));
        // }

        if (this.filteredData.length) {
            this.filteredData = this.filteredData.filter((x) => this.selectedLocationTypes.includes(x.type));
        }

        if (this.filteredData.length && this.isApplianceDisplay) {
            this.filteredData = this.filteredData.filter((x) => x.features && x.features.includes('Appliance Display'));
        }

        // Sort by distance
        if (this.filteredData.length) {
            this.filteredData.sort((a, b) => {
                const distA = a.contact?.distance ?? Infinity;
                const distB = b.contact?.distance ?? Infinity;
                return distA - distB;
            });
        }

        this.updateMapPins();
        this.updateResultList();
    }

    async initGoogleMapsScripts(googleMapsApiKey) {
        if (!window.google?.maps) {
            // prettier-ignore
            (g => {var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
                key: googleMapsApiKey,
                v: "weekly",
            });
        }

        await google.maps.importLibrary('maps');
        await google.maps.importLibrary('marker');
    }

    async initGoogleMap() {
        try {
            const mapId = this.googleMapsId;

            this.googleMap = new window.google.maps.Map(this.mapContainer, {
                mapId: mapId,
                zoomControl: true,
                zoomControlOptions: {
                    position: window.google.maps.ControlPosition['TOP_LEFT'],
                },
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
            });

            await this.createMapPinsAndInfoWindows();
        } catch (error) {
            console.error('Error initializing Google Map:', error);
        }
    }

    async createMapPinsAndInfoWindows() {
        this.mapBounds = new window.google.maps.LatLngBounds();

        if (this.storeData.length) {
            this.storeData.forEach(async (store) => {
                let latitude = parseFloat(store.contact?.latitude || 0);
                let longitude = parseFloat(store.contact?.longitude || 0);

                if (!(isNaN(latitude) || isNaN(longitude)) && latitude != 0 && longitude != 0) {
                    const markerPosition = {
                        lat: latitude,
                        lng: longitude,
                    };
                    this.mapBounds.extend(markerPosition);

                    this.placeMarkerAndInfoWindow(markerPosition, store);
                }
            });

            this.googleMap.fitBounds(this.mapBounds);
        }

        this.checkMapMaxZoom();
    }

    async placeMarkerAndInfoWindow(markerPosition, store) {
        const marker = new window.google.maps.marker.AdvancedMarkerElement({
            map: this.googleMap,
            position: markerPosition,
            title: store.name,
        });

        const infoWindow = new window.google.maps.InfoWindow();

        marker.addListener('click', () => {
            if (this.activeInfoWindow) {
                this.activeInfoWindow.close();
                this.activeInfoWindow = null;
            }

            infoWindow.setContent(this.generateInfoWindowHtml(store));
            infoWindow.open(this.googleMap, marker);

            this.activeInfoWindow = infoWindow;
            this.activeMarker = marker;
        });

        infoWindow.addListener('closeclick', () => {
            this.activeInfoWindow = null;

            if (this.activeMarker) {
                this.activeMarker = null;
            }
        });

        this.mapMarkers.set(store.handle.toString(), marker);
        this.infoWindows.set(store.handle.toString(), infoWindow);
    }

    generateInfoWindowHtml(store) {
        let street = store.contact.street_1;
        if (store.contact.street_2) {
            street += ' ' + store.contact.street_2;
        }
        const formattedAddress = `${street}<br>${store.contact.city}, ${store.contact.state} ${store.contact.postal_code}`;

        // let formattedHours = '';
        // if (Array.isArray(store.hours)) {
        //     store.hours.forEach(x => formattedHours += x.name + '<br>');
        // }

        let formattedHours = '';

        if (Array.isArray(store.hours)) {
            store.hours.forEach(x => {
                formattedHours += `<div class="hours-wrap">`;
                formattedHours += `<div class="day">${x.label}</div>`;
                formattedHours += `<div class="status">${x.hours}</div>`;

                // if (x.hours.toLowerCase() === 'closed') {
                //     formattedHours += `<div class="status">Closed</div>`;
                // } else {
                //     const [open, close] = x.hours.split(' - ');
                //     formattedHours += `<div class="status"><span class="time">${open}</span> - <span class="time">${close}</span></div>`;
                // }

                formattedHours += `</div>`;
            });
        }

        const outputFormattedHours = formattedHours ? `<div class="hours-container">${formattedHours}</div>` : '';

        let applianceDisplay = '';
        if (Array.isArray(store.features) && store.features.includes(this.allowedFeature)) {
            applianceDisplay = '<span class="store-locator-appliance-display"> <span class="store-locator-app-dot "> </span>Appliance Display</span>';
        }

        let distance = '';
        if (store.contact.distance) {
            distance = `<p>${store.contact.distance.toFixed()} Miles</p>`;
        }

        return `
            <div class="store-locator__infowindow" data-id="${store.erp_id}" data-handle="${store.handle}">
                <div class="store-locator__item-content">
                    <h4 class="store-locator__item-content-title">${store.name}</h4>
                    <div>
                        <span class="badge ${slugify(store.type)}">${store.type}</span>
                        ${applianceDisplay}
                    </div>
                    ${distance}
                    <div class="store-locator-address">${formattedAddress}</div>
                    ${outputFormattedHours}
                    <div class="button-wrap">
                        <p><a href="${store.path}" class="button btn btn--secondary">View Details</a></p>
                        <button type="button" class="button appointment-button btn btn--primary" data-appointment-trigger="" aria-label="Book an Appointment">Book an Appointment</button>
                    </div>
                </div>
            </div>
        `;
    }

    updateMapPins() {
        if (this.filteredData.length) {
            this.mapBounds = new window.google.maps.LatLngBounds();

            // loop through markers and show the ones that are in filtered data
            // adjust map display to zoom in on area
            this.mapMarkers.forEach((marker, handle) => {
                const showMarker = this.filteredData.find((x) => x.handle == handle);
                marker.setMap(showMarker ? this.googleMap : null);

                if (showMarker) {
                    this.mapBounds.extend(marker.position);
                }
            });

            // Regenerate infowindow content with updated distances
            this.filteredData.forEach((store) => {
                const infoWindow = this.infoWindows.get(store.handle.toString());

                if (infoWindow) {
                    infoWindow.setContent(this.generateInfoWindowHtml(store));
                }
            });

            this.googleMap.fitBounds(this.mapBounds);
            this.checkMapMaxZoom();
        } else {
            this.mapMarkers.forEach((x) => x.setMap(null));

            let position;
            if (this.latitude && this.longitude) {
                position = { lat: this.latitude, lng: this.longitude };
            } else {
                position = { lat: this.defaultLatitude, lng: this.defaultLongitude };
            }

            this.googleMap.setCenter(position);
            this.googleMap.setZoom(this.maximumZoom);
        }
    }

    updateResultList() {
        // show/hide list items based on filtered data
        if (this.filteredData.length) {
            this.noResultsMessage.style.display = 'none';

            this.storeListItems.forEach((item) => {
                const handle = item.dataset.handle;
                const showItem = this.filteredData.find((x) => x.handle == handle);

                item.style.display = showItem ? 'block' : 'none';

                if (!showItem) {
                    item.style.order = 999;
                }
            });

            // sort items based on filtered data
            let sort = 1;
            const storeItemsArray = Array.from(this.storeListItems);
            this.filteredData.forEach((store) => {
                const item = storeItemsArray.find((x) => x.dataset.handle == store.handle);

                if (item) {
                    // set distance
                    const distanceSpan = item.querySelector('.store-locator__results-item-distance');
                    const distance = store.contact.distance.toFixed();
                    distanceSpan.innerHTML = distance !== '0' ? distance + ' Miles' : '';

                    // update sort
                    item.style.order = sort;
                    sort++;
                }
            });
        } else {
            this.storeListItems.forEach((x) => (x.style.display = 'none'));
            this.noResultsMessage.style.display = 'block';
        }
    }

    checkMapMaxZoom() {
        const currentZoom = this.googleMap.getZoom();
        if (currentZoom > this.maximumZoom) {
            this.googleMap.setZoom(this.maximumZoom);
        }
    }

    getDistanceInMiles(lat1, lng1, lat2, lng2) {
        const toRadians = (degrees) => degrees * (Math.PI / 180);
        const earthRadiusMiles = 3958.8; // Radius of the Earth in miles

        const dLat = toRadians(lat2 - lat1);
        const dLng = toRadians(lng2 - lng1);

        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(toRadians(lat1)) * Math.cos(toRadians(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);

        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

        return earthRadiusMiles * c;
    }
}

customElements.define('store-locator', StoreLocator);
